module.exports = __webpack_public_path__ + "static/img/86ef30dd133ca930402e2aba09660506.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sol_icon4(4).jpg
// module id = wFU9
// module chunks = 1